module.exports = __webpack_public_path__ + "images/mdj/members/common/common_icon01-704347a063305c71cacb7663535a094c.png";